export default "__VITE_ASSET__e592d8f1__"